import {motion} from 'framer-motion';
import React from 'react';
import styled from 'styled-components';

import {Device} from '../../../constants';

const BadgeImage = styled(({...rest}) => <motion.img {...rest} />)`
  width: auto;
  height: 10em;
  display: block;
  position: absolute;
  bottom: 100%;
  z-index: 1;

  @media screen and ${Device.mobileL} {
    height: 6em;
    bottom: 98%;
  }
`;

export default BadgeImage;
